export const sportsData = [
  {
    _id: "67319b0821c86e068f6cfebe",
    name: "Cricket",
  },
  {
    _id: "67319b1621c86e068f6cfec0",
    name: "Football",
  },
  {
    _id: "67319b3221c86e068f6cfec2",
    name: "Padel",
  },
  {
    _id: "6731b9151ee1bef0122358e2",
    name: "Volleyball",
  },
  {
    _id: "673c464abab384ff6f630898",
    name: "Pickleball",
  },
  {
    _id: "673c4659bab384ff6f63089a",
    name: "Basketball",
  },
  {
    _id: "673c4670bab384ff6f63089c",
    name: "Cricket Net",
  },
  // {
  //   _id: '673c467ebab384ff6f63089e',
  //   name: 'All Sports',
  // },
];
